import React from 'react';
import Title from '../DashboardScreen/part/Title';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';

export default function LogoutScreen(props: { disconnect: Function }) {
	const { disconnect } = props;

	return (
		<Container maxWidth="lg" sx={{ mt: 4, mb: 4, backgroundColor: 'white' }}>
			<Grid container direction="column" alignItems="center" sx={{ mt: 4 }}>
				<Title>Déconnexion</Title>
			</Grid>
			<Grid container direction="column" alignItems="center" justifyContent="center" sx={{ backgroundColor: 'white', height: 150, textAlign: 'center' }}>
				<Typography>Ce fut un plaisir, à bientôt sur le merveilleux PHF Dashboard !</Typography>
				<Button sx={{ width: 200, height: 50, mt: 2 }} color="error" variant="contained" onClick={() => disconnect()}>
					Déconnexion
				</Button>
			</Grid>
		</Container>
	);
}
